import React, { useEffect, useState } from "react";
import SectionLoader from "../LodingScreen/SectionLoader";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { t } from "i18next";
import axios from "axios";
import { API_BASE_URL } from "../../redux/common/url";
import CityPopUp from "../../layout/header/PopUPCity";

function HeaderSearchBar({ selectedCityId }: any) {
  const location = useLocation();
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showCityPopup, setShowCityPopup] = useState(false);
  const [tests, setTests] = useState<any[]>([]);
  const [searchTermShow, setSearchTermShow] = useState<any>("");
  const [error, setError] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [isSearched, setIsSearched] = useState(false);
  const cityData = useSelector((state: any) => state.dashboard.city);

  useEffect(() => {
    if (!isSearched) return;
    const delayDebounce = setTimeout(() => {
      handleUniversalSearch(searchTerm);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleUniversalSearch = async (term: string) => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${API_BASE_URL}/tests/universal-search`,
        { SearchTerm: term, CityId: selectedCityId },
        {
          headers: {
            token: "6f905f5fc8577f0b4baee213e2f43f46",
            "Content-Type": "application/json",
          },
        }
      );
      const data = res?.data?.data || res?.data?.Data || [];
      if (Array.isArray(data) && data.length > 0) {
        setTests(data);
        setError(false);
      } else {
        setTests([]);
        setError(true);
      }
    } catch (err) {
      console.error("Search error:", err);
      setTests([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // Reset search states when the route changes
  useEffect(() => {
    setIsSearched(false); // Close the dropdown
    setSearchTerm(""); // Clear the search term
    setSearchTermShow(""); // Clear the displayed search term
    setTests([]); // Clear the search results
    setLoading(false); // Stop any loading state
  }, [location.pathname]); // Trigger when the route changes

  const handleSearch = (e: any) => {
    console.log("came", selectedCityId);

    if (!selectedCityId) {
      console.log("true");
      setShowCityPopup(true);
      return;
    }
    let val = e.target.value;
    setSearchTermShow(val);
    setSearchTerm(val);

    if (val.trim().length >= 3) {
      setIsSearched(true);
      setLoading(true);
    } else if (val.length === 0) {
      setIsSearched(false);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="main-div"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ position: "relative", width: "100%" }}>
          <div className="header-input-group">
            <input
              className="form-control rounded-pill py-2 pr-5 bg-transparent"
              type="search"
              value={searchTermShow}
              placeholder={t("search_teast_packages")}
              id="example-search-input"
              onChange={handleSearch}
            />
            <span className="input-group-append">
              <div className="input-group-text border-0 bg-transparent ml-n5">
                <i className="fa fa-search" style={{ color: "#114A82" }}></i>
              </div>
            </span>
          </div>
          {isSearched && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                backgroundColor: "white",
                textAlign: "left",
                padding: "10px",
                marginTop: "11px",
                maxHeight: "300px",
                overflowY: "auto",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                zIndex: 10,
              }}
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <SectionLoader />
                </div>
              ) : tests.length > 0 ? (
                tests.map((item: any, index: number) => {
                  const linkUrl = item?.url
                    ? new URL(item.url).pathname
                    : `/test/${item?.slug || item?.id}`;
                  return (
                    <Link
                      to={linkUrl}
                      key={index}
                      onClick={() => setIsSearched(false)}
                    >
                      <p
                        style={{
                          margin: 0,
                          padding: "5px 0",
                          cursor: "pointer",
                          color: "#555",
                        }}
                      >
                        {item?.name}
                      </p>
                    </Link>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "#555",
                  }}
                >
                  <p>No Test Found</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {showCityPopup && (
        <CityPopUp
          city={city}
          setCity={setCity}
          cityData={cityData}
          setModalIsOpenToTrue={() => setShowCityPopup(true)}
        />
      )}
    </>
  );
}

export default HeaderSearchBar;